import CritrereHeureController from './critere.heure.controller';

export default {
    bindings: {
        critere: '='
    },
    controller: CritrereHeureController,
    template: require('./critere.heure.tpl.html')
};
